var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Story'),_c('Life'),_c('Vid'),_c('Honor'),_c('Data')],1)}
var staticRenderFns = []

export { render, staticRenderFns }